module.exports = __webpack_public_path__ + "media/application/images/icons/ui-icons_777777_256x240-602585991ebd05e30aeb2b9579b5185e.png";